import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const SituacoesNaFiscalizacao = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="SITUAÇÕES CONSTATADAS DURANTE A FISCALIZAÇÃO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Atendimento em Grupo" nome="atendimentogrupo" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Delimitação de Área Limpa e Área Suja" nome="areasujalimpa" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Tapete Sanitizante" nome="tapete" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Local Reservado para Calçados na Entrada das Salas de Atendimentos(opcional)" nome="calcado" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Orientações - Medidas de Proteção contra o COVID-19" nome="orientacoescovid" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Procedimento de Operação Padrão (POP) para Funcionamento do Estabelecimento" nome="pop" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Monitoramento de Sintomas de COVID-19" nome="monitoriamentocovid" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Profissionais e Colaboradores" nome="pofissionaiscolab" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Pacientes" nome="pacientes" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Há Distanciamento entre os Participantes" nome="distanciamento" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>

                </Caixa>
            )
        }
        return partes
    }
}

export default SituacoesNaFiscalizacao